module.exports = __webpack_public_path__ + "img/1-4.a622ee10.png";